<div class="background">
  <nav class="navbar navbar-light first-nav">
    <div>
    </div>
    <p [routerLink]="['/']" class="window-logo">{{constants.WINDOW_SWAP_TXT}}</p>
    <div (click)="OnClickClose()" id="closebutton">
      <img class="close-button" src="{{constants.LOGIN_CLOSE_BUTTON}}" />
    </div>
  </nav>
  <section *ngIf="!paymentSuccess" class="container section-1">
    <div class="row form-row">
      <div class="col form-field">
        <div class="toggle-button-field" *ngIf="!checked">
          <label class="switch">
            <input [checked]="checked" (change)="paymentToggle()" type="checkbox">
            <span [ngClass]="{'slider-20 round-20': primeamount === 20 , 'slider round': primeamount === 50}"> </span>
          </label>

        </div>
        <div class="toggle-button-field" *ngIf="checked">
          <label class="switch-1">
            <input [checked]="checked" (change)="paymentToggle()" type="checkbox">
            <span [ngClass]="{'slider-20 round-20': primeamount === 20 , 'slider round': primeamount === 50}"> </span>
          </label>
        </div>

        <ngx-stripe-card-group [formGroup]="stripeTest" [elementsOptions]="elementsOptions">
          <div>
            <input type="text" formControlName="name" class="name-input" placeholder="Name on card"
              (focus)="foundError = false" />
          </div>
          <div class="card-number">
            <ngx-stripe-card-number [options]="cardOptions" (focus)="foundError = false"></ngx-stripe-card-number>
          </div>
          <div class="card-details">
            <div class="card-expiry">
              <ngx-stripe-card-expiry [options]="cardOptions" (focus)="foundError = false"></ngx-stripe-card-expiry>
            </div>
            <div class="card-cvc">
              <ngx-stripe-card-cvc [options]="cardOptions" (focus)="foundError = false"></ngx-stripe-card-cvc>
            </div>
          </div>

          <button [disabled]="isLoading" id="btn" type="submit" (click)="createToken()" class="pay-btn" value="20">
            <mat-spinner *ngIf="isLoading" strokeWidth="3" [diameter]="20" class="text-center">
              {{constants.LOADING_TEXT}}
            </mat-spinner>
            <span *ngIf="!isLoading" id="USD"><b>{{buttonValue}}</b></span>
          </button>
        </ngx-stripe-card-group>
        <p *ngIf="foundError" class="error" id="error">{{errorMessage}}</p>
      </div>
    </div>
  </section>
  <section *ngIf="paymentSuccess" class="section-2 container">
    <div class="row success">
      <div class="col-6 image">
        <img src="{{constants.PAYMENT_SUCCESS}}" alt="">
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 content">
        <h3><b>{{constants.WELCOME_TO_TXT}}</b><br> <b>{{constants.WINDOWSWAP_ALL_TXT}}</b></h3>
        <h4>{{constants.UNIQUE_WORLD}}</h4>
        <img class="inside-img" src="{{constants.PAYMENT_SUCCESS}}" alt="">
        <button [routerLink]="['/']" class="button-custom">{{constants.CLOSE_PAGE_TXT}}</button>
      </div>
    </div>
  </section>
</div>